import { render } from "./SettingsPage.vue?vue&type=template&id=40ae5bee&scoped=true"
import script from "./SettingsPage.vue?vue&type=script&lang=js"
export * from "./SettingsPage.vue?vue&type=script&lang=js"

import "./SettingsPage.vue?vue&type=style&index=0&id=40ae5bee&scoped=true&lang=css"

import exportComponent from "/usr/share/node/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ae5bee"]])

export default __exports__